import React, { useEffect, useState } from 'react'
import { useRequestData } from '../../../Utilities/hooks'
import { SelectBox } from '@tecuity/granite-ui/SelectBox'
import { IconButton } from '@tecuity/granite-ui/IconButton'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { Spinner } from '../../Loaders/Loaders'
import Portal from 'components/Portal/Portal'
import { Modal, ConfirmDialog } from 'components/Modal/Modal'
import * as api from '../../../requests'
import { GraniteDataGrid } from '@tecuity/granite-ui'
import ConversionModal from './ConversionModal'
import Pencil from '@tecuity/sos-icons/react/pencil-solid'
import PlusHeavy from '@tecuity/sos-icons/react/plus-heavy'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'
import { noop } from 'utilities'
import { useDispatch } from 'react-redux'
import { setErrorToast, setSuccessToast } from '../../../actions'

const BusinessConversionsXref = () => {
  const dispatch = useDispatch()
  const receiptItemTypes = useRequestData(api.GET_SETTINGS_RECEIPT_ITEM_TYPES, [], [])
  const appReports = useRequestData(api.GET_APP_REPORTS, [], [])
  const [filingType, setFilingType] = useState('')
  const [filingTypeOptions, setFilingTypeOptions] = useState([])
  const [recordTypeOptions, setRecordTypeOptions] = useState([])
  const [recordSubTypeOptions, setRecordSubTypeOptions] = useState([])
  const [businessStatusTypeOptions, setBusinessStatusTypeOptions] = useState([])
  const [rows, setRows] = useState([])
  const [selectedRow, setSelectedRow] = useState(defaultConversionXref)
  const [conversionModalOpen, setConversionModalOpen] = useState(false)
  const [deleteModalOpen, setDeleteModalOpen] = useState(false)
  const [isAdding, setIsAdding] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    api.GET_ALL_ENUM_LOOKUP_TYPE(
      'BusinessFilingType',
      (res) => {
        // console.log(res)
        setFilingTypeOptions([
          ...res
            .filter((t) => t.IsActive && t.IsConversion)
            .map((t) => ({
              value: t.Id,
              label: t.Name,
            })),
        ])
        setLoading(false)
      },
      (err) => {
        setFilingTypeOptions([])
        console.error(err.message)
        setLoading(false)
      }
    )
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'Business',
      'RecordType',
      (res) => {
        // console.log(res)
        setRecordTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ])
      },
      (err) => {
        setRecordTypeOptions([])
        console.error(err.message)
      }
    )
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'Business',
      'RecordSubType',
      (res) => {
        // console.log(res)
        setRecordSubTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ])
      },
      (err) => {
        setRecordSubTypeOptions([])
        console.error(err.message)
      }
    )
    api.GET_ACTIVE_BASIC_LOOKUP_TYPES(
      'Business',
      'StatusType',
      (res) => {
        // console.log(res)
        setBusinessStatusTypeOptions([
          ...res.map((t) => ({
            value: t.Id,
            label: t.Name,
          })),
        ])
      },
      (err) => {
        setBusinessStatusTypeOptions([])
        console.error(err.message)
      }
    )
  }, [])

  const getList = () => {
    //api call
    if (filingType) {
      setLoading(true)
      api.GET_SETTINGS_ALL_BUSINESS_CONVERSION_TYPES_XREF(
        filingType,
        (data) => {
          setLoading(false)
          setRows(
            (data || []).map((item) => {
              return {
                ...item,
                InitialRecordTypeName: getRecordTypeName(item.InitialRecordTypeId),
                InitialRecordSubTypeName: getRecordSubTypeName(item.InitialRecordSubTypeId),
                ConvertedRecordTypeName: getRecordTypeName(item.ConvertedRecordTypeId),
                ConvertedRecordSubTypeName: getRecordSubTypeName(item.ConvertedRecordSubTypeId),
              }
            })
          )
        },
        (err) => {
          setLoading(false)
          console.error(err)
        }
      )
    } else {
      setRows([])
    }
  }

  useEffect(() => {
    getList()
  }, [filingType, recordTypeOptions, recordSubTypeOptions])

  const getRecordTypeName = (id) => {
    const type = recordTypeOptions.find((type) => type.value === id)
    return type ? type.label : ''
  }
  const getRecordSubTypeName = (id) => {
    const type = recordSubTypeOptions.find((type) => type.value === id)
    return type ? type.label : ''
  }

  const columns = [
    {
      field: 'InitialRecordTypeName',
      flex: 1,
      headerName: 'Initial Record Type',
    },
    {
      field: 'InitialRecordSubTypeName',
      flex: 1,
      headerName: 'Initial Record Sub Type',
    },
    {
      field: 'ConvertedRecordTypeName',
      flex: 1,
      headerName: 'Converted Record Type',
    },
    {
      field: 'ConvertedRecordSubTypeName',
      flex: 1,
      headerName: 'Converted Record Sub Type',
    },
    {
      field: 'Actions',
      headerName: 'Actions',
      flex: 0.5,
      resizeable: false,
      disableColumnMenu: true,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        return (
          <div className="action-icons-wrapper" style={{ display: `inline` }}>
            <IconButton
              onClick={() => {
                setSelectedRow(params.row)
                setConversionModalOpen(true)
                setIsAdding(false)
              }}
              icon={<Pencil />}
              label="Edit"
            />
            <IconButton
              onClick={() => {
                setSelectedRow(params.row)
                setDeleteModalOpen(true)
              }}
              icon={<CrossHeavy />}
              label="Delete"
            />
          </div>
        )
      },
    },
  ]

  const closeModal = (refreshList) => {
    // console.log(refreshList)
    if (refreshList) getList()
    setConversionModalOpen(false)
  }

  const finishDelete = () => {
    api.DELETE_CONVERSION_TYPE_XREF(
      selectedRow.ConversionRecordTypeXrefId,
      () => {
        getList()
        dispatch(setSuccessToast('Successfully Deleted XRef'))
      },
      (err) => {
        dispatch(setErrorToast('Failed to Delete XRef'))
      }
    )
  }

  return (
    <div className="settings-list-view">
      <h2>Business Conversions Xref</h2>
      <div className="custom-correspondence-options">
        <SelectBox
          label="Filing Type"
          value={filingType}
          onChange={(val) => {
            setFilingType(val)
          }}
          options={filingTypeOptions}
        />

        <ContextButton
          variant="primary"
          customCss={`height: min-content; margin-top: 5px`}
          onClick={() => {
            setSelectedRow(defaultConversionXref)
            setConversionModalOpen(true)
            setIsAdding(true)
          }}
          disabled={!filingType}
          rightIcon={
            <div className="checkmark-wrapper">
              <PlusHeavy />
            </div>
          }
        >
          Add Conversion
        </ContextButton>
        {loading && (
          <div className="type-loader">
            <Spinner size="small" themeColor="dark-neutral" />
          </div>
        )}
      </div>

      <div className="settings-content">
        <div className="settings-full-width-column">
          <GraniteDataGrid
            columns={columns}
            rows={rows}
            getRowId={(row) => row.ConversionRecordTypeXrefId}
            pageSize={10}
            rowsPerPageOptions={[10]}
            onRowDoubleClick={(r) => {
              setSelectedRow(r.row)
              setConversionModalOpen(true)
              setIsAdding(false)
            }}
            rowHeight={32}
          />
        </div>
        <Portal isOpened={conversionModalOpen}>
          <Modal
            title={`${isAdding ? 'Add' : 'Edit'} Conversion`}
            modalSize="large"
            autoHeight
            closeModal={() => setConversionModalOpen(false)}
          >
            <ConversionModal
              selectedRow={selectedRow || defaultConversionXref}
              closeModal={closeModal}
              recordTypeOptions={recordTypeOptions}
              recordSubTypeOptions={recordSubTypeOptions}
              businessStatusTypeOptions={businessStatusTypeOptions}
              getRecordTypeName={getRecordTypeName}
              getRecordSubTypeName={getRecordSubTypeName}
              receiptItemTypes={receiptItemTypes}
              appReports={appReports}
              filingType={filingType}
            />
          </Modal>
        </Portal>
        <Portal isOpened={deleteModalOpen}>
          <ConfirmDialog
            closeModal={() => {
              setDeleteModalOpen(false)
            }}
            onModalClosed={noop}
            message={`Are you sure you want to delete configuration?`}
            buttons={[
              { label: 'No', onClick: noop, className: 'btn-default' },
              {
                label: 'Yes',
                onClick: () => {
                  finishDelete()
                },
                className: 'btn-danger',
              },
            ]}
            modalStyle={{ borderRadius: 3 }}
          />
        </Portal>
      </div>
    </div>
  )
}

export default BusinessConversionsXref

const defaultConversionXref = {
  ConversionRecordTypeXrefId: 0,
  ConversionFilingTypeId: 0,
  InitialRecordTypeId: 0,
  InitialRecordSubTypeId: 0,
  ConvertedRecordTypeId: 0,
  ConvertedRecordSubTypeId: 0,
  PostConversionBusinessStatusTypeId: 0,
  ReportIds: [],
  ReceiptItemTypeIds: [],
}
